import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import Chart from '../../../../../components/Rechart/Chart'
import http from '../../../../../config/BaseUrl'

function EmailShare() {

  const [data, setData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const fetchGraphData = async () => {
    try {
      setIsLoading(true)
      await http.get(`dashboard-graph/sharing/email`).then( res =>{
        if(res.data.graphData){
          setIsLoading(false)
          setData(res.data.graphData)
        }
      }).catch((err) => {
        setIsLoading(false)
      })
    } catch (error) {
      
    }
  }

  const graphTotalText = {
    week: `This Week`,
    month: 'This Month',
    year: 'This Year'
  }

  useEffect(()=>{
    fetchGraphData()
  }, [])


  return (
    <Chart 
      sectionTitle={"Email"} 
      sectionName={"email"}
      loading={isLoading}
      dataSet={data} 
      width={330} 
      height={180} 
      dataKey={"share"}
      graphTotalText={graphTotalText}
    />
  )
}

export default EmailShare
